export const LocalityAbbreviationDictionary = new Map<string, string>([
  ['Аобл', 'А.обл.'],
  ['Респ', 'Респ.'],
  ['в-ки', 'выселки'],
  ['вн.тер. г.', 'вн. тер. г.'],
  ['гп.', 'гп.'],
  ['г', 'г.'],
  ['г-к', 'городок'],
  ['гп', 'гп.'],
  ['д', 'д.'],
  ['дп', 'дп.'],
  ['ж/д в-ка', 'ж/д ветка'],
  ['ж/д к-т', 'ж/д комбинат'],
  ['ж/д бл-ст', 'ж/д блокпост'],
  ['ж/д п.п.', 'ж/д путевой пост'],
  ['ж/д пл-ка', 'ж/д площадка'],
  ['ж/д рзд', 'ж/д разъезд'],
  ['ж/д ст', 'ж/д станция'],
  ['ж/д_будка', 'ж/д будка'],
  ['ж/д_казарм', 'ж/д казарма'],
  ['ж/д_оп', 'ж/д о.п.'],
  ['ж/д_платф', 'ж/д платформа'],
  ['ж/д_пост', 'ж/д пост'],
  ['ж/д_рзд', 'ж/д разъезд'],
  ['ж/д_ст', 'ж/д станция'],
  ['з-ка', 'заимка'],
  ['зим.', 'зимовье'],
  ['кв-л', 'квартал'],
  ['киш.', 'кишлак'],
  ['кп', 'курортный поселок'],
  ['кп.', 'курортный поселок'],
  ['м', 'местечко'],
  ['м-ко', 'местечко'],
  ['м.р-н', 'мун. район'],
  ['мкр', 'мкр.'],
  ['нп', 'нп.'],
  ['обл', 'обл.'],
  ['п', 'п.'],
  ['п/ст', 'п/ст.'],
  ['п-к', 'починок'],
  ['пгт', 'пгт.'],
  ['пл.р-н', 'пл. район'],
  ['пос.рзд', 'поселок разъезда'],
  ['пос.рзд.', 'поселок разъезда'],
  ['рзд', 'разъезд'],
  ['рзд.', 'разъезд'],
  ['рп', 'рп.'],
  ['с', 'с.'],
  ['с/а', 'с/а'],
  ['с/мо', 'с/мо'],
  ['с/о', 'с/о'],
  ['с/п', 'сельское поселение'],
  ['с/с', 'сельсовет'],
  ['сл', 'слобода'],
  ['сл.', 'слобода'],
  ['снт', 'снт.'],
  ['сп', 'сп.'],
  ['ст', 'станция'],
  ['ст.', 'станция'],
  ['ст-ца', 'станица'],
  ['тер', 'тер.'],
  ['тер. СНТ', 'тер. СНТ'],
  ['у', 'улус'],
  ['у.', 'улус'],
  ['х', 'х.'],
])

export const StreetAbbreviationDictionary = new Map<string, string>([
  ['б-р', 'бульвар'],
  ['взв.', 'взвоз'],
  ['д', 'д.'],
  ['днп', 'днп.'],
  ['дор', 'дорога'],
  ['ж/д_будка', 'ж/д будка'],
  ['ж/д_казарм', 'ж/д казарма'],
  ['ж/д_оп', 'ж/д о.п.'],
  ['ж/д_платф', 'ж/д платформа'],
  ['ж/д_пост', 'ж/д пост'],
  ['ж/д_рзд', 'ж/д разъезд'],
  ['ж/д_ст', 'ж/д станция'],
  ['ж/р', 'жилой район'],
  ['кв-л', 'квартал'],
  ['км', 'км.'],
  ['м', 'местечко'],
  ['мгстр.', 'магистраль'],
  ['месторожд.', 'месторождение'],
  ['мкр', 'мкр.'],
  ['н/п', 'н/п.'],
  ['наб', 'набережная'],
  ['нп', 'нп.'],
  ['п', 'п.'],
  ['п/о', 'п/о.'],
  ['п/р', 'пром. район'],
  ['п/ст', 'п/ст.'],
  ['пер', 'пер.'],
  ['пл', 'площадь'],
  ['пл-ка', 'площадка'],
  ['пл.р-н', 'пл. район'],
  ['п-к', 'починок'],
  ['платф', 'платформа'],
  ['пр-кт', 'проспект'],
  ['р-н', 'район'],
  ['рзд', 'разъезд'],
  ['с', 'с.'],
  ['с/т', 'с/т.'],
  ['сзд.', 'съезд'],
  ['сл', 'слобода'],
  ['снт', 'снт.'],
  ['ст', 'станция'],
  ['стр', 'строение'],
  ['тер', 'территория'],
  ['тер.СОСН', 'тер. СОСН'],
  ['тер.ф.х.', 'территория ФХ'],
  ['туп', 'тупик'],
  ['ул', 'ул.'],
  ['ус.', 'усадьба'],
  ['уч-к', 'участок'],
  ['ф/х', 'ф/х.'],
  ['х', 'хутор'],
  ['ш', 'шоссе'],
  ['ю.', 'юрты'],
])
